import ImagesController from './images.controller';

export default {
    template: require('./images.tpl.html'),
    controller: ImagesController
};
